import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useField } from 'formik';

import styles from './Select.module.scss';

interface Props {
  name: string;
  placeholder?: string;
  options: string[];

  onFocus?: React.FocusEventHandler;
  onBlur?: React.FocusEventHandler;
}

const Select = ({ name, placeholder, options, onFocus, onBlur }: Props) => {
  const [field, meta, helpers] = useField(name);
  const [showOptions, setShowOptions] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);

  const { value } = field;
  const setValue = (newValue: string) => {
    helpers.setValue(newValue);
  };

  const isInvalid = Boolean(meta.error);

  return (
    <Form.Group onFocus={onFocus} onBlur={onBlur}>
      <div
        className={`${styles.select} ${
          isInvalid ? styles.select__invalid : ''
        }`}
        role="button"
        tabIndex={-1}
        onFocus={() => setShowOptions(true)}
        onBlur={() => setShowOptions(false)}
      >
        {value || <span style={{ color: 'gray' }}>{placeholder}</span>}
      </div>

      <div
        className={styles.select__dropdown}
        style={{ visibility: showOptions ? 'visible' : 'hidden' }}
      >
        {options.map((option, index) => {
          let className = styles.select__dropdown_option;
          if (index === selectedIndex) {
            className += ` ${styles.select__dropdown_option__selected}`;
          }

          return (
            <div
              key={option}
              role="presentation"
              className={className}
              onMouseEnter={() => setSelectedIndex(index)}
              onMouseDown={(event) => {
                event.stopPropagation();
                setValue(option);
              }}
            >
              {option}
            </div>
          );
        })}
      </div>

      <Form.Control.Feedback
        type="invalid"
        style={{
          display: 'block',
          visibility: isInvalid ? 'visible' : 'hidden',
        }}
      >
        {meta.error}&nbsp;
      </Form.Control.Feedback>
    </Form.Group>
  );
};

Select.defaultProps = {
  placeholder: '',
  onFocus: () => {},
  onBlur: () => {},
};

export default Select;
